import { useActiveConversation } from '../components/chat/ActiveConversationContext';
import { useChatOverlayOpen } from './use-chat-overlay';
import { useSitePaneFits } from './use-site-pane';
import { useDraftReviewFlow, type DraftReviewFlow } from './draft-review-store';

export function useDraftReviewPane(): DraftReviewFlow | null {
  const flow = useDraftReviewFlow();
  const chatOpen = useChatOverlayOpen();
  const fits = useSitePaneFits();
  const { activeConversationId } = useActiveConversation();
  if (!flow?.beside || !chatOpen || !fits) return null;
  if (flow.conversationId !== activeConversationId) return null;
  return flow;
}
